export type Module = {
  id: number;
  name: string;
  parentId: number;
  metaData?: string;
  moduleConfig?: ModuleConfig;
};
export type ModuleConfig = {
  inputElementsOrder: number[];
  formulaElementsOrder: number[];
  assumptions: string;
  modulesOrder: number[];
};
export type InputType = "Dependent Dropdown" | "Dropdown" | "Number Input" | "Radio" | "Year Input" | "Text Input";
export type InputElement = {
  id: number;
  name: string;
  type: InputType;
  default: string;
  moduleId?: number;
  inputConfig?: InputConfig;
};
export enum LoadState {
  "NotLoaded",
  "Loading",
  "Loaded",
  "Error",
  "Mutated",
}
export type InputConfig = {
  min?: number;
  max?: number;
  dependentColumn?: string[];
  options?: string[];
  dependentOptions?: DependentOption[];
  inputHelp?: string;
  displayName?: string;
  group?: string;
};
export type DependentOption = { keys: Keys[]; options: string[] };
export type Keys = { column: string; value: string };
export type FormulaElement = {
  id: number;
  key: string;
  name: string;
  group?: string;
  type: FormulaType;
  moduleId?: number;
  formulaConfig?: {
    expressions?: Expression[];
    showInCalculate?: boolean;
    hideInDetailResults?: boolean;
    unitRate?: number;
    quantity?: number;
  };
  comment: string;
};
export type FormulaType = "Fixed Value" | "Look Up" | "Formula";
export type Expression = {
  id: string;
  condition: string;
  pageNo?: string;
  lookUpName?: string;
  unitRate: string;
  quantity: string;
  lookupValueType?: string;
  cost: string;
  year?: string;
};

export type FormulaResult = {
  result: { [key: string]: string | number | null }[];
  errors: FormulaError[];
};

export type ErrorType = "Input Error" | "Condition" | "Quantity" | "Unit Rate" | "Look Up";
export type FormulaError = {
  type: ErrorType;
  formulaId: string;
  conditionId: string;
  description: string;
};

export type LookupData = {
  id: number;
  lookupGroup: string[];
  key: string;
  pageNo: string;
  name: string;
  stateName: string;
  lookupValue: number[];
  unit: string;
  year: string;
};

export const QueryKeys = {
  Modules: "Modules",
  Users: "Users",
  LookupDataPageNo: "LookupDataPageNo",
  Assumptions: "Assumptions",
  Logo: "Logo",
  Reports: "Reports",
  ReportArchives: "ReportArchives",
  ProfileImage: "ProfileImage",
  User: "User",
} as const;

export type User = {
  id: string;
  name: string;
  email: string;
  userType: number;
  lockoutEnabled: boolean;
};

export type Report = {
  id: number;
  name: string;
  moduleId: number;
  selectedInputs: { [key: string]: string | number | null } | null;
  formulasResult: FormulasResult;
  createdDate: Date;
  createdBy: number;
};

export interface ReportDto extends Report {
  year: string;
}

export type FormulasResult = {
  detailedResult: { [key: string]: string | number | null }[];
  calculatedResult: { [key: string]: string | number | null }[];
};

export type ReportData = {
  id: number;
  name: string;
  moduleId: number;
  year: string;
};

export type ReportArchive = {
  id: number;
  name: string;
  fileName: string;
  createdOn: string;
  config: {
    reportIds: number[];
  };
};
